import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { tryToFetchActivities, tryToFetchLogsStats } from '../../../store/brokers/partner/agent-activities/agentActivitiesSlice';
import InsightsComponent from './insights/InsightsComponent';
import ActivitiesTable from './tables/ActivitiesTable';
import Button from '../../../shared/button';
import Input from '../../../shared/input';


const AgentActivities = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState<string>();
    const [rows, setRows] = useState<Array<any>>([]);
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
        null,
        null,
    ]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<any>();
    const [totalSessions, setTotalSessions] = useState<number>();
    const paginationData = useAppSelector((state) => state?.agentActivities?.agentActivities?.data?.page);
    const logsStats = useAppSelector((state) => state?.agentActivities?.stats);
    const purchaseLoading = useAppSelector((state) => state.agentActivities.activitiesAreLoading);
    const state = useAppSelector((state) => state.agentActivities);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10
        })
    }

    useEffect(() => {
        if (logsStats) {
            setTotalSessions(logsStats?.totalSessions)
        }
    }, [logsStats])

    const onChange = (newRange: any) => {
        if (Array.isArray(newRange) && newRange[0] && newRange[1]) {
            setDateRange([newRange[0], newRange[1]]);
            setIsOpen(false);
            onResetPaginationState();
        }
    };

    const onChangeSelectedAgent = (e: any, type?: string) => {
        setSelectedAgent(e)
        onResetPaginationState();
    }

    useEffect(() => {
        if (state.agentActivities) {
            const rows = state.agentActivities?.data?.elements
            setRows(rows);
        }
    }, [state.agentActivities]);

    const onGettingFilters = (stats?: boolean) => {
        let data: any = {
            exclude: ['accounting_agent']
        }
        if ((dateRange?.[0] !== null) || (dateRange?.[1] !== null)) {
            data = {
                ...data || {},
                fromDate: dateRange?.[0],
                toDate: dateRange?.[1]
            }
        }
        if (selectedAgent && selectedAgent?.value !== 'all_agents') {
            data = {
                ...data || {},
                agent: selectedAgent?.value
            }
        }
        if (search && !stats) {
            data = {
                ...data || {},
                search: search,
            }
        }
        return data ? { data: data } : {};
    }

    const onGettingData = async () => {
        try {
            const data = onGettingFilters()
            const fetchData = {
                ...paginationState || {},
                ...data || {}
            }
            await dispatch(tryToFetchActivities(fetchData)).unwrap()
        } catch (err) {
            // err
        }
    }

    const onGettingStats = async () => {
        try {
            const data = onGettingFilters(true)
            await dispatch(tryToFetchLogsStats(data)).unwrap()
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingData()
        onGettingStats()
    }, [paginationState])

    const onClickClearAllFilter = () => {
        setDateRange([null, null])
        setSearch(undefined);
        setSelectedAgent(undefined)
        onResetPaginationState();
    }

    const onChangeSearchValue = (value: string | null | undefined, type: string) => {
        setSearch(value || undefined)
        onResetPaginationState()
    }

    const onClickLogDetails = (id: string) => {
        navigate(`/ai-logs/${id}`)
    }

    const onRefreshData = () => {
        onGettingData()
        onGettingStats()
    }

    return (
        <div>
            <div>
                <p className='page-title'>AI Agent Activities</p>
            </div>
            <div>
                <InsightsComponent
                    dateRange={dateRange}
                    isOpen={isOpen}
                    selectedAgent={selectedAgent}
                    totalSessions={totalSessions}
                    allStats={logsStats}
                    setIsOpen={setIsOpen}
                    onChange={onChange}
                    onRefreshData={onRefreshData}
                    onChangeSelectedAgent={onChangeSelectedAgent}
                />
            </div>
            {/* <div>
                <p className='text-primary-light font-bold text-sm mt-2 mb-4'>Date Filters</p>
                <div className='mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 sm:gap-2 lg:gap-4'>
                    <Datepicker
                        placeholder='Initiated'
                        containerStyle='mb-0'
                        inputValue={dateFilters?.fromDate}
                        onChangeInput={onChangeSelectedFilter}
                        inputUniqueName={'fromDate'}
                    />
                    <Datepicker
                        placeholder='Completed'
                        containerStyle='mb-0'
                        inputValue={dateFilters?.toDate}
                        onChangeInput={onChangeSelectedFilter}
                        inputUniqueName={'toDate'}
                    />
                </div>
            </div> */}
            <div className={`flex flex-wrap justify-between items-center mt-3 bg-[#f4f4f4] mb-2 p-1 !rounded w-full`}>
                <div>
                    <Input
                        placeholder={'Filter Table'}
                        dataQa={'search'}
                        containerStyle='mb-0 pb-0 relative min-w-[500px]'
                        inputStyle={`mb-0 border-0 focus:outline-none`}
                        icon={'/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearchValue}
                        hideInputSpace={true}
                    />
                </div>
                <div className='flex flex-row justify-end space-x-4'>
                    <div className='flex flex-row justify-end ml-2'>
                        <Button
                            label='Clear Filters'
                            className={'btn-primary-text-underline min-w-auto'}
                            onClickButton={() => onClickClearAllFilter()}
                        />
                    </div>
                </div>
            </div>
            <ActivitiesTable
                rows={rows}
                rowsLoading={purchaseLoading}
                paginationData={paginationData}
                setPaginationState={setPaginationState}
                onClickLogDetails={onClickLogDetails}
            />
        </div>

    )
}
export default AgentActivities;